module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-01-517eeab93b715c4109ce327f9fa53f0b.jpg";